import { Modal } from 'antd'

import { ActionButton } from '@eastcoal/common/components/Button/ActionButton'
import { pick } from '@eastcoal/common/utils/object'

import { SubmitType } from '@eastcoal/formily/components/CrudForm/enums/SubmitType'
import { useKeeponButton } from '@eastcoal/formily/components/CrudForm/shared/hooks/useKeeponButton'
import { useCrudFormStore } from '@eastcoal/formily/components/CrudForm/Store/hooks/useStore'

import { AuctionFeeConfirmSubmitButtonProps } from './interface'
import { useFeeConfirm } from './useFeeConfirm'

/**
 * 竞价场次发布按钮（带服务费/入场费二次确认）
 */
export const AuctionFeeConfirmSubmitButton = ({
  keepon,
  forceShow,
  type: externalType,
  icon: externalIcon,
  children: externalChildren,
  ...restProps
}: AuctionFeeConfirmSubmitButtonProps) => {
  const { form, submitLoading } = useCrudFormStore(state =>
    pick(state, ['form', 'submitLoading'])
  )

  const {
    isModalOpen,
    confirmContent,
    handleClick,
    handleConfirm,
    handleCancel
  } = useFeeConfirm({
    // 与原 SubmitButton 保持一致：keepon 模式下提交成功后重置表单以便连续录入
    onSubmitted: () => {
      if (keepon) {
        form.reset()
      }
    }
  })

  const { type, ghost, icon, children, hide } = useKeeponButton({
    keepon,
    forceShow,
    type: externalType,
    icon: externalIcon,
    children: externalChildren
  })

  if (hide) {
    return null
  }

  return (
    <>
      <ActionButton
        ghost={ghost}
        htmlType='submit'
        icon={icon}
        loading={submitLoading}
        type={type}
        onClick={() => handleClick({ submitType: SubmitType.SUBMIT, keepon })}
        {...restProps}
      >
        {children}
      </ActionButton>
      <Modal
        cancelText='否'
        okText='是'
        open={isModalOpen}
        title='提示'
        onCancel={handleCancel}
        onOk={handleConfirm}
      >
        {confirmContent}
      </Modal>
    </>
  )
}
